/** FAQ, Support, and Advertising page copy (German). */
export const pagesMessagesDe = {
  faq: {
    pageTitle: "Häufig gestellte Fragen",
    pageSubtitle: "Antworten auf häufige Fragen zu WasOK",
    seoTitle: "FAQ — WasOK",
    seoDescription:
      "Antworten auf häufige Fragen zu WasOK, dem Scannen von Produkten, Datenschutz und Bewertungen.",
    items: [
      {
        question: "Wie funktioniert WasOK?",
        answer:
          "WasOK hilft dir, dich daran zu erinnern, welche Produkte dir gefallen haben oder nicht, indem du Barcodes scannst und deine Bewertungen und Notizen speicherst. Scanne einfach den Barcode eines Produkts, bewerte es, füge Notizen hinzu, und beim nächsten Scan desselben Produkts siehst du sofort deine vorherige Bewertung.",
      },
      {
        question: "Werden meine Daten in der Cloud gespeichert?",
        answer:
          "Nein! Alle deine Daten werden lokal auf deinem Gerät gespeichert. Wir synchronisieren deine Informationen nicht mit der Cloud, sodass deine Einkaufshistorie und Produktmeinungen vollständig privat bleiben. Das bedeutet allerdings auch, dass du dein Gerät sichern solltest, wenn du deine Daten behalten möchtest.",
      },
      {
        question: "Brauche ich eine Internetverbindung, um WasOK zu nutzen?",
        answer:
          "Nein, WasOK funktioniert vollständig offline. Da alle deine Daten lokal auf deinem Gerät gespeichert werden, kannst du Produkte scannen, Bewertungen hinzufügen und deinen Verlauf ansehen, ohne eine Internetverbindung zu benötigen.",
      },
      {
        question: "Kann ich WasOK für jede Art von Produkt verwenden?",
        answer:
          "Ja! WasOK funktioniert mit jedem Produkt, das einen Barcode hat. Ob Lebensmittel, Kosmetik, Haushaltsartikel, Elektronik oder alles andere mit Barcode — du kannst es scannen und deine Meinung dazu speichern.",
      },
      {
        question: "Wie scanne ich einen Barcode?",
        answer:
          "Öffne einfach die WasOK-App und tippe auf die Scan-Schaltfläche. Richte deine Kamera auf den Barcode des Produkts, und die App erkennt und scannt ihn automatisch. Achte darauf, dass der Barcode gut beleuchtet und scharf ist, um beste Ergebnisse zu erzielen.",
      },
      {
        question: "Kann ich Fotos zu meinen Produktbewertungen hinzufügen?",
        answer:
          "Ja! Du kannst jeder Produktbewertung Fotos hinzufügen. Das ist besonders hilfreich, um dich an Verpackungsdetails, Zutatenlisten oder andere visuelle Informationen zu erinnern, die dir helfen könnten, dich daran zu erinnern, warum dir ein Produkt gefallen hat oder nicht.",
      },
      {
        question: "Welche Informationen kann ich zu Produkten speichern?",
        answer:
          "Du kannst Bewertungen (1-5 Sterne), Textnotizen, Fotos, den bezahlten Preis, den Kaufort und eigene Kategorien speichern. Diese umfassenden Informationen helfen dir, beim Einkaufen fundierte Entscheidungen zu treffen.",
      },
      {
        question: "Kann ich Einkaufslisten erstellen?",
        answer:
          "Ja! Mit WasOK kannst du Einkaufslisten aus Produkten erstellen, die du bereits bewertet hast. So erinnerst du dich leicht daran, welche Produkte du geliebt hast und wieder kaufen möchtest.",
      },
      {
        question: "Wie organisiere ich meine Produkte?",
        answer:
          "Du kannst Produkte mithilfe eigener Kategorien organisieren. Du könntest zum Beispiel Kategorien wie „Snacks“, „Kaffee“, „Hautpflege“ oder „Reinigungsprodukte“ anlegen. So kannst du deine Bewertungen leicht nach Art durchsuchen.",
      },
      {
        question: "Ist WasOK kostenlos?",
        answer:
          "Ja, WasOK ist vollständig kostenlos herunterzuladen und zu nutzen. Es gibt keine In-App-Käufe, Abonnements oder versteckten Gebühren. Wir glauben, dass jeder Zugang zu einer privaten Möglichkeit haben sollte, sich seine Produktpräferenzen zu merken.",
      },
      {
        question: "Ist WasOK barrierefrei?",
        answer:
          "WasOK wurde so gestaltet, dass es von möglichst vielen Menschen genutzt werden kann. Die App enthält Barrierefreiheitsfunktionen wie Unterstützung für Screenreader, skalierbaren Text und einen optionalen Hochkontrastmodus.",
      },
      {
        question: "Was passiert, wenn ich die App deinstalliere?",
        answer:
          "Da alle Daten lokal auf deinem Gerät gespeichert werden, löscht die Deinstallation der App alle deine Produktbewertungen, Notizen und Einkaufslisten. Exportiere deine Daten unbedingt vorher, wenn du ein Backup behalten möchtest.",
      },
      {
        question: "Kann ich meine Daten exportieren?",
        answer:
          "Ja, mit WasOK kannst du deine Daten zu Sicherungszwecken exportieren. Du kannst alle deine Bewertungen in eine Datei exportieren, die du auf deinem Gerät oder in einem Cloud-Speicher deiner Wahl speichern kannst.",
      },
      {
        question: "Verfolgt WasOK meinen Standort?",
        answer:
          "Nein, WasOK verfolgt deinen Standort nicht. Du kannst zwar den Namen des Geschäfts, in dem du ein Produkt gekauft hast, manuell eingeben, aber die App verwendet weder GPS noch Standortdienste.",
      },
      {
        question: "Kann ich WasOK auf mehreren Geräten nutzen?",
        answer:
          "Derzeit synchronisiert WasOK nicht zwischen Geräten, da alle Daten lokal gespeichert werden. Jedes Gerät hat seine eigene, separate Datenbank mit Produkten und Bewertungen.",
      },
      {
        question: "Was, wenn ein Barcode nicht gescannt wird?",
        answer:
          "Wenn ein Barcode nicht gescannt wird, stelle sicher, dass er gut beleuchtet und scharf ist. Du kannst auch versuchen, die Kameralinse zu reinigen. Ist der Barcode beschädigt oder unklar, kannst du die Barcode-Nummer möglicherweise manuell eingeben.",
      },
    ],
    cta: {
      heading: "Noch Fragen?",
      body: "Wende dich an unser Support-Team — wir helfen dir gerne weiter.",
      button: "Support kontaktieren",
    },
  },
  support: {
    pageTitle: "Support",
    seoTitle: "Support — WasOK",
    seoDescription:
      "Hilfe zu WasOK: Support kontaktieren, Fehler melden und Feedback teilen.",
    getHelp: {
      title: "Hilfe erhalten",
      body: "Wir sind hier, um dir zu helfen, das Beste aus WasOK herauszuholen. Falls du Probleme hast oder Fragen aufkommen, stehen dir mehrere Ressourcen zur Verfügung.",
    },
    faq: {
      title: "Häufig gestellte Fragen",
      body: "Bevor du uns kontaktierst, schau dir unseren FAQ-Bereich an, in dem wir die häufigsten Fragen zu WasOK beantworten. Dort findest du ausführliche Informationen darüber, wie die App funktioniert, zum Datenschutz, zur Datenspeicherung und mehr.",
    },
    contact: {
      title: "Support kontaktieren",
      body: "Solltest du die gesuchte Antwort nicht finden, hilft dir unser Support-Team gerne weiter. Du erreichst uns unter:",
      emailLabel: "E-Mail:",
      responseTime: "Wir antworten in der Regel innerhalb von 24-48 Stunden",
    },
    bugs: {
      title: "Fehler melden",
      body: "Einen Fehler gefunden? Wir freuen uns über deine Hilfe, WasOK zu verbessern. Bitte gib bei der Fehlermeldung Folgendes an:",
      items: [
        "Eine detaillierte Beschreibung des Problems",
        "Schritte zur Reproduktion des Problems",
        "Dein Gerätemodell und die Android-Version",
        "Screenshots oder Bildschirmaufnahmen, falls möglich",
      ],
      sendPrefix: "Fehlerberichte senden an:",
    },
    featureRequests: {
      title: "Funktionswünsche",
      bodyBefore: "Hast du eine Idee für eine neue Funktion? Wir freuen uns, von dir zu hören! Sende deine Vorschläge an",
      bodyAfter:
        ". Wir können nicht jede Anfrage umsetzen, berücksichtigen aber jedes Feedback sorgfältig bei der Planung zukünftiger Updates.",
    },
    knownIssues: {
      title: "Bekannte Probleme",
      body: "Uns sind derzeit folgende Probleme bekannt, an deren Behebung wir arbeiten:",
      items: [
        "Manche Barcodes werden bei schlechten Lichtverhältnissen möglicherweise nicht erkannt — versuche es mit einer Taschenlampe",
        "Sehr lange Produktnotizen können auf älteren Geräten etwas länger zum Speichern brauchen",
        "Foto-Vorschaubilder können auf hochauflösenden Bildschirmen pixelig wirken",
      ],
    },
    appUpdates: {
      title: "App-Updates",
      body: "Wir veröffentlichen regelmäßig Updates mit neuen Funktionen, Verbesserungen und Fehlerbehebungen. Halte WasOK über den Google Play Store aktuell, um die neuesten Verbesserungen zu erhalten.",
    },
    community: {
      title: "Community",
      body: "Werde Teil unserer Community von Nutzerinnen und Nutzern, die mit WasOK klügere Einkaufsentscheidungen treffen. Teile Tipps, stelle Fragen und vernetze dich mit anderen Nutzern auf unseren Social-Media-Kanälen.",
    },
    emergency: {
      title: "Dringender Support",
      body: 'Falls du ein kritisches Problem hast, das dich an der Nutzung der App hindert, markiere deine E-Mail bitte mit „URGENT“ in der Betreffzeile, und wir behandeln deine Anfrage vorrangig.',
    },
    cta: {
      heading: "Brauchst du weitere Hilfe?",
      body: "Unser Support-Team ist für dich da. Zögere nicht, uns bei Fragen oder Anliegen zu kontaktieren.",
      button: "Support per E-Mail",
    },
  },
  advertising: {
    pageTitle: "Werbung & Monetarisierung",
    seoTitle: "Werbung — WasOK",
    seoDescription: "Wie WasOK mit Werbung und Monetarisierung umgeht.",
    approach: {
      title: "Unser Ansatz",
      body: "Bei WasOK glauben wir, dass deine Einkaufsgewohnheiten und Produktmeinungen privat und persönlich sind. Unser Geschäftsmodell spiegelt diesen Grundwert wider.",
    },
    noAds: {
      title: "Keine Werbung",
      body: "WasOK zeigt keinerlei Werbung an. Wir werden dir niemals Anzeigen basierend auf den gescannten Produkten, deinen Bewertungen oder anderen Daten zeigen, die du in der App erstellst. Deine Erfahrung mit WasOK ist vollständig werbefrei.",
    },
    noDataSelling: {
      title: "Kein Datenverkauf",
      body: "Wir verkaufen, vermieten oder teilen deine Daten nicht mit Werbetreibenden, Datenhändlern oder anderen Dritten. Da alle deine Daten lokal auf deinem Gerät gespeichert werden, haben wir selbst keinen Zugriff darauf. Deine Produktbewertungen, Einkaufslisten und Notizen gehören allein dir.",
    },
    noTracking: {
      title: "Kein Tracking",
      body: "WasOK verwendet keine Tracking-Pixel, Analysedienste oder andere Technologien, die dein Verhalten überwachen oder Informationen mit Dritten teilen. Wir verfolgen weder, welche Produkte du scannst, noch in welchen Geschäften du einkaufst oder wie du die App nutzt.",
    },
    sustainability: {
      title: "Wie wir uns finanzieren",
      body: "Du fragst dich vielleicht, wie wir WasOK ohne Werbung oder Datenverkauf kostenlos halten. Unser Ansatz ist einfach:",
      items: [
        {
          label: "Kostenlos und offen:",
          text: "WasOK ist für alle kostenlos nutzbar, ohne Premium-Stufen oder Bezahlschranken",
        },
        {
          label: "Schlanker Betrieb:",
          text: "Wir halten unsere Kosten niedrig, indem wir effiziente, datenschutzfreundliche Software entwickeln",
        },
        {
          label: "Optionale Spenden:",
          text: "Nutzerinnen und Nutzer, die WasOK lieben, können uns durch freiwillige Spenden unterstützen",
        },
        {
          label: "Open Source:",
          text: "Wir bieten möglicherweise Beratungs- oder individuelle Entwicklungsdienstleistungen für Organisationen an",
        },
      ],
    },
    noAffiliate: {
      title: "Keine Affiliate-Links",
      body: "WasOK verwendet keine Affiliate-Links und erhält keine Provisionen von Händlern. Wenn du ein Produkt scannst, leiten wir dich nirgendwohin weiter, um es zu kaufen. Die App dient ausschließlich deiner persönlichen Dokumentation und Entscheidungsfindung.",
    },
    noPromotions: {
      title: "Keine Produktwerbung",
      body: "Wir nehmen keine Zahlungen von Marken oder Herstellern an, um deren Produkte zu bewerben. WasOK wird dir niemals Produkte vorschlagen, bestimmte Marken hervorheben oder deine Bewertungen in irgendeiner Weise beeinflussen. Deine Meinungen gehören dir allein.",
    },
    partnerships: {
      title: "Partnerschaften mit Dritten",
      body: "WasOK arbeitet nicht mit Marketingunternehmen, Datenaggregatoren oder Werbenetzwerken zusammen. Wir agieren unabhängig und stellen deinen Datenschutz über alles andere.",
    },
    future: {
      title: "Zukunftspläne",
      body: "Wir setzen uns dafür ein, WasOK werbefrei und datenschutzfreundlich zu halten. Sollten wir in Zukunft jemals ein nachhaltiges Geschäftsmodell einführen müssen, werden wir:",
      items: [
        "Jede Änderung frühzeitig ankündigen",
        "Niemals Kompromisse bei Datenschutz oder Datensicherheit eingehen",
        "Immer eine Möglichkeit bieten, die App ohne Tracking oder Werbung zu nutzen",
        "Auf das Feedback und die Anliegen der Nutzer hören",
      ],
    },
    supporting: {
      title: "WasOK unterstützen",
      body: "Wenn du WasOK liebst und unsere Mission des datenschutzfreundlichen Einkaufsgedächtnisses unterstützen möchtest, kannst du:",
      items: [
        "Deinen Freunden und deiner Familie von der App erzählen",
        "Eine positive Bewertung im Google Play Store hinterlassen",
        "Uns dein Feedback und deine Vorschläge mitteilen",
        "Eine freiwillige Spende in Erwägung ziehen (sobald verfügbar)",
      ],
    },
    cta: {
      heading: "Fragen zu unseren Richtlinien?",
      body: "Wir sind transparent darüber, wie WasOK funktioniert. Wenn du Fragen zu unserem Ansatz bei Datenschutz, Monetarisierung oder Nachhaltigkeit hast, melde dich gerne bei uns.",
      button: "Kontaktiere uns",
    },
  },
};
